import { render, staticRenderFns } from "./RecordIndex.vue?vue&type=template&id=922fe978&scoped=true&"
import script from "./RecordIndex.vue?vue&type=script&lang=js&"
export * from "./RecordIndex.vue?vue&type=script&lang=js&"
import style0 from "./RecordIndex.vue?vue&type=style&index=0&id=922fe978&lang=scss&scoped=true&"
import style1 from "./RecordIndex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922fe978",
  null
  
)

export default component.exports